<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">List</span>
        <h3 class="page-title">Laporan</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
          </div>
          <div class="card-body p-0 pb-3 text-center" style="overflow-x:scroll">
            <d-row style="margin:auto">
            <d-col md="4"  class="form-group" style="text-align:left">
              Showing 
              <select v-model="ipp" >
                <option value="5">5 entries</option>
                <option value="10">10 entries</option>
                <option value="15">15 entries</option>
                <option value="20">20 entries</option>
                <option value="0" selected>All</option>
              </select>          
            </d-col>
            <d-col md="4"  class="form-group">
            </d-col>
            <!--d-col md="4"  class="form-group">
              <d-form-input type="text" id="feInputSearch" placeholder="Search" v-model.trim="search" /-->
            </d-col>
            </d-row>
        <b-table
            :data="isEmpty ? [] : data"
            :loading="loading"
            :mobile-cards="hasMobileCards"
            paginated
            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"            
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Action" width="40" numeric sortable>
                    <button type="button" class="btn-primary btn-sm" style="padding:0.15rem 0.5rem !important" @click="open_data(props.row.link)"><i class="material-icons">search</i></button>
                </b-table-column>

                <!--b-table-column field="category" label="Category" sortable>
                    <span class="tag is-success">
                    {{ props.row.category }}
                    </span>
                </b-table-column-->

                <b-table-column field="name" label="Name" sortable>
                    {{ props.row.name }}
                </b-table-column>

            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';

    export default {
        data() {
            return {
                data:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: true,
                sortField:'category',
                sortOrder:'desc',
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                sort:'category,name',
                defaultSortOrder:'desc',
                page:1,
                perPage:5,
                total:2,
                ipp:5,
                search:'',
                columns:[
                    {
                        field: 'id',
                        label: 'Action',
                        width: '40',
                        numeric: true
                    },
                    {
                        field: 'category',
                        label: 'Category',
                    },
                    {
                        field: 'name',
                        label: 'Name',
                    },
                ]
            }
        },
        watch:{
          ipp(){
           if (this.ipp>0) this.perPage=this.ipp
           else this.perPage=this.total
           this.update_data();
          },
          search(){
           if(this.search.length>3||!this.search.length)this.update_data()
          }
        },
        methods:{
          onPageChange(page){
           this.page=page;
           this.update_data();
          },
          onSort(field,order){
           if ( !this.loading ){           
            this.sortField=field;
            this.sortOrder=order;
            this.update_data();
           }
          },
          update_data(){
          this.data=[
{link:'donator-report',name:'Laporan Donatur'},
{link:'donation-report',name:'Laporan Donasi'},
];
/*
           this.loading=true;
           this.axios.post( env.server+'/reports/list',{
             start: this.page,
             length: this.perPage>0 ? this.perPage: this.total,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.items;
               this.total=resp.data.total_results;
             }
           );
*/
          },
          open_data(link){
            console.log('link',link);
            this.$router.push({name:link});
          },
        },
        mounted(){
          this.update_data();
        },
    }
</script>
